import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Navigation from "../navigation/mainNavBar";

import "./View.scss";

import Footer from "../footer/Footer";

const View = () => {
  let navigate = useNavigate();
  const [data, setData] = useState({});

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");

  useEffect(() => {
    const formData = new FormData();
    formData.append("id", id);

    fetch("./requestApplication.php", {
      method: "POST",
      // credentials: "include",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status == "error") {
          let path = `/`;
          navigate(path);
          return () => {};
        }
        setData(data);
      })
      .catch((error) => console.error(error));
  }, []);

  useEffect(() => {
    const sectionOffset =
      document.querySelector("section:first-of-type").offsetTop * 0.8;
    window.scrollTo({
      top: sectionOffset,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div className="view">
      <Navigation isView={true} applicationId={id} />
      <div className="content">
        <div className="title">WildLandsRP</div>
        <div className="sub-title">
          Przyjaciele, wrogowie i fortuna czekają na Ciebie!
        </div>
        <div className="main-butons-line"></div>
      </div>
      <div className="section-title">Odpowiedzi</div>
      <section className="grid2">
        <div className="grid-item"></div>
        <div className="grid-item">
          <div>
            <h3>STEAMID64:</h3>
            <p>{data.steamId}</p>
          </div>
          <div>
            <h3>Nazwa discord:</h3>
            <p>{data.discordName}</p>
          </div>
          <div>
            <h3>DiscordID:</h3>
            <p>{data.discordId}</p>
          </div>
          <div>
            <h3>Wiek:</h3>
            <p>{data.age}</p>
          </div>
          <div>
            <h3>
              Opisz swoją postać i podaj nam trochę informacji na jej temat:
            </h3>
            <p>{data.description}</p>
          </div>
          <div>
            <h3>Czym jest RolePlay i jakie są jego podstawowe zasady?</h3>
            <p>{data.goodRoleplay}</p>
          </div>
          <div>
            <h3>
              Podaj przykład, jak można rozpocząć interakcję z innym graczem:
            </h3>
            <p>{data.interaction}</p>
          </div>
          <div>
            <h3>
              Wymień dwa najważniejsze wydarzenia z tamtych czasów, które mogą
              wpłynąć na rozgrywkę:
            </h3>
            <p>{data.events}</p>
          </div>
          <div>
            <h3>
              Jakie są główne cechy społeczne i kulturowe tamtych czasów, które
              należy uwzględnić podczas gry?
            </h3>
            <p>{data.socialCulturalTraits}</p>
          </div>
          <div>
            <h3>
              Jakie technologie są dostępne dla postaci w tamtych czasach?
            </h3>
            <p>{data.technologies}</p>
          </div>
          <div>
            <h3>
              Czy jesteś gotów na interakcje RP (Role Play) z NPC (Non-Player
              Character), czy raczej skupiasz się tylko na interakcjach z innymi
              graczami?
            </h3>
            <p>{data.npcInteraction}</p>
          </div>
          <div>
            <h3>
              Jak można zakończyć scenę roleplay, gdy nie czujesz się komfortowo
              z danej sytuacji?
            </h3>
            <p>{data.uncomfortableScene}</p>
          </div>
          <div>
            <h3>
              Opisz, jak powinieneś postępować, gdy twoja postać zostanie ranna
              w interakcji z innymi graczami:
            </h3>
            <p>{data.injury}</p>
          </div>
          <div>
            <h3>
              Ile osób może jednocześnie przebywać w grupie bandytów lub
              szeryfów podczas odgrywania akcji hostylnych?
            </h3>
            <p>{data.groupSize}</p>
          </div>
          <div>
            <h3>
              Twoja postać doznała pewnych obrażeń. Opisz co jej jest, tak
              jakbyś to zrobił pisząc opis stanu pacjenta:
            </h3>
            <p>{data.injuryDescription}</p>
          </div>
          <div>
            <h3>
              Co masz zamiar grać na naszym serwerze:
            </h3>
            <p>{data.ideas}</p>
          </div>
          <div>
            <h3>
              Czy preferujesz grę samemu, w mniejszych grupach czy w większych
              zespołach? Dlaczego?
            </h3>
            <p>{data.playStyle}</p>
          </div>
        </div>
        <div className="grid-item"></div>
      </section>
      <Footer />
    </div>
  );
};

export default View;
